'use client';
/** @jsxImportSource @emotion/react */

import * as React from 'react';
import { type SVGProps } from 'react';
const Add = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z" fill="currentColor" />
  </svg>
);
export default Add;
